
export default {
    namespaced: true,
    state: {
        optId: -1,
        loading: false,
        tbListCategory: [],
        tbListInfo: [],
        tbListLine: [],
        tbListChild: [],
        tbListClock: [],
        listShowInfo: [],
        openChildArray: [],
        categoryShowId: "default",
        viewClockedIsShow: "1",
        viewColorIndex:0,
        viewColorValue: "",
        viewCategoryNotShow: "",
        viewColor: {
            index: Math.floor(Math.random()*8),
            colors: [
                "#A9C6A8",
                "#C6C9F2",
                "#D9E4DD",
                "#F7D3BA",
                "#F4EDB4",
                "#FFAAA7",
                "#A7C5EB",
                "#F6D1E5",
            ],
        },
        priorityItems: [
            {priority: 1, color: "#FD302C", text: "重要且紧急"},
            {priority: 2, color: "#FF9E00", text: "重要不紧急"},
            {priority: 3, color: "#0042FF", text: "不重要但紧急"},
            {priority: 4, color: "#999999", text: "不重要不紧急"}
        ]
    },
    mutations: {
        setOptId: function(state, payload){
            state.optId = payload;
        },
        setLoading: function(state, params){
            state.loading = params;
        },
        initListData(state, payload){
            state.tbListCategory = payload.listCategoryList;
            state.tbListInfo = payload.listInfoList;
            state.tbListLine = payload.listTimeLineList;
            state.tbListChild = payload.listChildList;
            state.tbListClock = payload.listClockList;
            state.optId = payload.lastOptId;
            state.tbListInfo.sort((nextItem, item)=>{
                return item.sortNum - nextItem.sortNum
            })

            // 分类排序 倒叙
            state.tbListCategory.sort((nextItem, item)=>{
                return item.sortNum - nextItem.sortNum
            })
            // 视图 已打卡清单 显示设置
            let viewMatterClockedIsShow = window.localStorage.getItem("viewMatterClockedIsShow");
            if(viewMatterClockedIsShow) {
                state.viewMatterClockedIsShow = viewMatterClockedIsShow;
            }else{
                state.viewMatterClockedIsShow = "1";
            }
            // 视图 颜色 显示设置
            let viewMatterColorIndex = window.localStorage.getItem('viewMatterColorIndex');
            let viewMatterColorValue = window.localStorage.getItem('viewMatterColorValue');
            if(viewMatterColorIndex){
                state.viewMatterColorIndex = parseInt(viewMatterColorIndex);
                state.viewMatterColorValue = viewMatterColorValue;
            }else{
                state.viewMatterColorIndex = 0;
                state.viewMatterColorValue = "";
            }
            // 视图不展示的分类
            let categoryShowId = window.localStorage.getItem('categoryShowId');
            if(categoryShowId){
                state.categoryShowId = categoryShowId;
            }else{
                state.categoryShowId = 'all';
            }
        },
        clearTbListData: function(state){
            state.tbListCategory = [];
            state.tbListInfo = [];
            state.tbListLine = [];
            state.tbListChild = [];
            state.tbListClock = [];
            state.optId = -1;
            state.showMatterInfo = [];
            state.openChildArray = [];

        },

        /**
         * 设置清单分类
         */
        setCategory: function(state, payload){
            payload.forEach((item)=>{
                if(item.dataAction === "add"){
                    item.dataAction = "orig"
                    state.tbListCategory.push(item);
                }else if(item.dataAction === "update"){
                    // 修改分类
                    state.tbListCategory.forEach((categoryItem, index, array)=>{
                        if(item.categoryId === categoryItem.categoryId){
                            item.dataAction = "orig";
                            array[index] = item;
                        }
                    })
                }
            });

            // 分类排序 倒叙
            state.tbListCategory.sort((nextItem, item)=>{
                return item.sortNum - nextItem.sortNum
            })
        },

        setList: function(state, payload){
            payload.forEach((item)=>{
                if(item.dataAction === "add"){
                    item.dataAction = "orig";
                    state.tbListInfo.unshift(item);
                }else if(item.dataAction === "update"){

                    state.tbListInfo.forEach((matterItem, index, array) => {
                        if (matterItem.inventoryId === item.inventoryId) {
                            item.dataAction = "orig";
                            array[index] = item;
                        }
                    })
                }
            })
        },

        setLine: function(state, payload){
            payload.forEach((item)=>{
                if(item.dataAction === "add"){
                    item.dataAction = "orig";
                    state.tbListLine.unshift(item);
                }else if(item.dataAction === "update"){
                    state.tbListLine.forEach((matterItem, index, array) => {
                        if (matterItem.linkInventoryId === item.linkInventoryId
                            && matterItem.startDate === item.startDate
                            && matterItem.dataType === item.dataType) {
                            item.dataAction = "orig";
                            array[index] = item;
                        }
                    })
                }
            })
        },
        /**
         * 设置子任务
         * @param state
         * @param payload
         */

        setChild: function(state, payload) {
            payload.forEach((item)=>{
                if(item.dataAction === "add"){
                    item.dataAction = "orig";
                    state.tbListChild.unshift(item);
                }else if(item.dataAction === "update"){
                    state.tbListChild.forEach((childItem,childIndex,childArray)=>{
                        if(item.childId === childItem.childId){
                            item.dataAction = "orig";
                            childArray[childIndex] = item;
                        }
                    })
                }
            })
        },
        /**
         * 设置打卡记录
         * @param state
         * @param payload
         */
        setClock: function(state, payload) {
            payload.forEach((item)=>{
                if(item.dataAction === "add"){
                    item.dataAction = "orig"
                    state.tbListClock.unshift(item);
                }else{
                    state.tbListClock.forEach((clockItem)=>{
                        if(item.linkDataId === clockItem.linkDataId && item.clockDate === clockItem.clockDate){
                            clockItem.clockState = item.clockState;
                            clockItem.clockTimeStamp = item.clockTimeStamp;
                        }
                    })
                }
            });
        },
        setDeleteData: function(state, payload){
            payload.forEach((item)=>{
                if(item.deleteType === "inventory"){
                    // 删除清单
                    state.tbListInfo.forEach((matterItem, index, array) => {
                        if(item.deleteDataId === matterItem.inventoryId) {
                            array.splice(index, 1);
                        }
                    })
                }else if(item.deleteType === "inventory_child"){
                    // 删除子任务
                    state.tbListChild.forEach((childItem, index, array)=>{
                        if(item.deleteDataId === childItem.childId){
                            array.splice(index, 1);
                        }
                    })
                }else if(item.deleteType === "inventory_branch"){
                    // 删除时间线
                    state.tbListLine.forEach((lineItem, index, array)=>{
                        if(lineItem.branchInventoryId === lineItem.linkInventoryId
                            && lineItem.branchStartDate === lineItem.startDate
                            && lineItem.branchDataType === lineItem.dataType){
                            array.splice(index, 1);
                        }
                    })
                }else if(item.deleteType === "inventory_category"){
                    // 删除分类
                    state.tbListCategory.forEach((categoryItem, index, array)=>{
                        if(item.deleteDataId === categoryItem.categoryId){
                            array.splice(index, 1);
                        }
                    })
                    if(item.deleteDataId === state.categoryShowId){
                        state.categoryShowId = "all";
                        window.localStorage.setItem("categoryShowId", "all");
                    }
                }
            })
        },
        /**
         * 设置清单背景色下标
         * @param state
         */
        setViewColorIndex: function(state){
            let nextIndex = state.viewColors.index + 1;
            if (nextIndex > 7){
                nextIndex = 0
            }
            state.viewColors.index = nextIndex
        },
        /**
         * 设置 是否显示 已打卡
         * @param state
         * @param payload
         */
        setClockedIsShow: function(state, payload){
            state.viewMatterClockedIsShow = payload;
            window.localStorage.setItem("viewMatterClockedIsShow", payload);
        },
        /**
         * 设置 是否显示 无清单的分类
         * @param state
         * @param payload
         */
        setCategoryShowId: function(state, payload){
            state.categoryShowId = payload;
            window.localStorage.setItem("categoryShowId", payload);
        },
        /**
         * 设置 视图显示颜色
         * @param state
         * @param params
         */
        setViewColor: function(state, params){
            state.viewColorIndex = params.index;
            state.viewColorValue = params.value;
            window.localStorage.setItem("viewColorIndex", params.index);
            window.localStorage.setItem("viewColorValue", params.value);
        },

        setOpenChildArray: function(state, payload){
            const index = state.openChildArray.indexOf(payload);
            if(index === -1){
                // 增加
                state.openChildArray.push(payload);
            }else{
                // 删除
                state.openChildArray.splice(index, 1);
            }
        }
    },
    actions:{

    },
    getters:{

    }
}